import React from "react";
import { InfoText, InfoImage } from "components/items";
import infoImage01 from "image/infoImage-01.png";

const infoImageObj = [
	{
		id: "infoImage-01",
		style: {
			backgroundImage: `url(${infoImage01})`,
		},
		color: "bgColor-main",
		text: `CP비누 생산량 \n월 400,000개 `,
	},
];

const sectionTitle = [
	{
		text: "국내 최대의",
		color: "default",
		break: false,
	},
	{
		text: "고체 화장품",
		color: "main",
		break: true,
	},
	{
		text: "제조 공장",
		color: "main",
		break: true,
	},
];

const drawInfoImage = () => {
	return infoImageObj.map((el) => {
		return <InfoImage obj={el} key={el.id} />;
	});
};

const HomeOneImageInfo = () => {
	return (
		<section className="HomeOneImageInfo">
			<div className="con">
				<InfoText
					title={sectionTitle}
					paragraph="동구밭 팩토리는 발달장애인과 비장애인이 함께 월 40만 개의 최고 품질 고체화장품을 생산하는 고체화장품 전문 제조 공장입니다. CP(Cold Process) 비누, 약산성 비누, 설거지비누, 샴푸바, 린스바, 입욕제 등 플라스틱과 보존제, 화학성분을 사용하지 않는 자연유래 성분의 친환경 제품 생산에 최적화 되어 있습니다. 또한 모든 공정은 발달장애인 사원도 일할 수 있도록 안전하고 정확한 절차를 지키도록 설계되어 있습니다."
					btnText="제조 문의하기"
					link="#contact"
				/>
				<div className="wrap-infoImage">{drawInfoImage()}</div>
			</div>
		</section>
	);
};

export default HomeOneImageInfo;
